import React from "react";
import { isAdaApp } from "../utils/white-label";

const ADATheme = React.lazy(() => import("./ada"));

export default function ThemeProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <>
            <React.Suspense fallback={null}>
                {isAdaApp() && <ADATheme />}
            </React.Suspense>
            {children}
        </>
    );
}
